/** ==============================
 * Mixin utilizado nos relatórios
 ================================= */
import { differenceInDays } from 'date-fns'
import { mapGetters } from 'vuex'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('salesPerformance', ['getMaxDays'])
  },

  watch: {
    /**
     * Exibe o loader do gráfico conforme variações na prop
     * @param {boolean} newValue: se deve exibir o carregamento
     */
    isLoading: {
      handler(newValue) {
        if (newValue === false) {
          this.$refs.chart.chart.hideLoading()
        } else {
          this.$refs.chart.chart.showLoading()
        }
      }
    }
  },

  methods: {
    /**
     * Valida se o range do input data é menor que o getMaxDays, caso seja maior
     * Envia um toast e seta para a data default
     * @param {Object} item Object data do filtro
     * @returns datas dentro do limite
     */
    validateDateRange(item) {
      const startDate = new Date(item.value.start)

      const endDate = new Date(item.value.end)

      const diffInDays = differenceInDays(endDate, startDate)

      if (this.getMaxDays !== null && diffInDays > this.getMaxDays) {
        const newStartDate = new Date(endDate)

        newStartDate.setDate(newStartDate.getDate() - 7)

        const dateFilter = this.usedFilters.find(
          (filter) => filter.text === 'Data'
        )

        if (dateFilter) {
          if (dateFilter.value && dateFilter.value.start) {
            dateFilter.value.start = newStartDate
          }
        }

        this.$bus.$emit('show-alert-chip', {
          message: `Data inválida. O limite de busca é de ${this.getMaxDays} dias entre datas.`
        })

        return newStartDate
      } else {
        return startDate
      }
    }
  }
}
